import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { styled } from '@this/constants/themes';
import { observer } from 'mobx-react';
import { Typography, Box, Button } from '@material-ui/core';
import type OpenMeeting from '@this/domain/appoint/open_meeting';
import type OpenMeetingBlockedSlot from '@this/domain/appoint/open_meeting_blocked_slot';
import { H2 } from '@this/components/appoint/common';
import AppointContext from '@this/components/appoint/appoint_context';
import HoverActionBox from '@this/components/appoint/hover_action_box';
import { TheLeftHead, LeftSection, LeftButtonSection, LeftButtonWrap } from './form';

type Props = {
  openMeeting: OpenMeeting;
  handleBlockedSlotRemove: (s: OpenMeetingBlockedSlot) => void;
  handleSave: () => void;
  handleCancel: (blockedSlots: OpenMeetingBlockedSlot[]) => void;
};

const BlockedSlotForm = observer(({ openMeeting, handleBlockedSlotRemove, handleSave, handleCancel }: Props) => {
  const contextValue = useContext(AppointContext);

  const [oldBlockedSlots, setOldBlockedSlots] = useState<OpenMeetingBlockedSlot[] | undefined>(undefined);

  const handleSetOldBlockedSlots = () => {
    if (oldBlockedSlots) {
      return;
    }

    setOldBlockedSlots(openMeeting.openMeetingBlockedSlots.map(s => _.clone(s)));
  };

  // マウント時に1回発動
  useEffect(() => {
    handleSetOldBlockedSlots();
  }, []);

  const onSave = () => {
    setOldBlockedSlots(undefined);
    handleSave();
  };

  const onCancel = () => {
    handleCancel(oldBlockedSlots || []);
  };

  return (
    <div>
      <TheLeftHead display="flex" alignItems="flex-start">
        <H2 style={{ margin: '0 auto 0 0', fontSize: '16px', fontWeight: 'bold' }}>除外日時を選択中</H2>
      </TheLeftHead>
      <LeftSection>
        <Box padding="0 20px">
          <Typography style={{ fontSize: '10px', marginBottom: '10px' }}>選択中の除外日時</Typography>
          {openMeeting.openMeetingBlockedSlots.length > 0 ? (
            <>
              {openMeeting.openMeetingBlockedSlots
                .sort((a, b) => (a.startAt < b.startAt ? -1 : 1))
                .map(s => (
                  <HoverActionBox
                    key={s.startAt.format()}
                    clearTitle="この除外日時を削除"
                    onClear={() => handleBlockedSlotRemove(s)}
                  >
                    <Typography key={s.startAt.format()}>{s.timeText}</Typography>
                  </HoverActionBox>
                ))}
            </>
          ) : (
            <NoBlockedSlot>除外日時なし</NoBlockedSlot>
          )}
        </Box>
      </LeftSection>
      <LeftButtonSection>
        <Box display="flex" padding="0 10px">
          <Box flexGrow={999}>
            <>
              <LeftButtonWrap display="flex" isMobile={contextValue.isMobile} style={{ flexWrap: 'nowrap' }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => onCancel()}
                  style={{ flexGrow: 1, marginRight: 10, padding: 10, background: '#fff', lineHeight: 1 }}
                >
                  キャンセル
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onSave()}
                  style={{ flexGrow: 1, padding: 10, lineHeight: 1 }}
                >
                  除外日時を決定
                </Button>
              </LeftButtonWrap>
            </>
          </Box>
        </Box>
      </LeftButtonSection>
    </div>
  );
});

const NoBlockedSlot = styled.div`
  padding: 10px 12px;
  color: #909090;
  border: solid 1px;
  border-radius: 3px;
  font-size: 12px;
`;

export default BlockedSlotForm;
